import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { StepperDialogComponent } from 'src/app/components/stepper-dialog/stepper-dialog.component';
import { Item } from 'src/app/models/SelectItems';
import { AdminService } from 'src/app/services/admin.service';
import { GeneralService } from 'src/app/services/general.service';
import { MenuService } from 'src/app/services/menu.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent {
  @ViewChild(StepperDialogComponent) stepperDialogComponent!: StepperDialogComponent;
  graphdata: any[] = [];
  visibleColumnData: Item[] = [];
  visibleColumnsId:any[] = [];
  graphHeader :any[]=[];
  canView:boolean = false;
  canEdit:boolean = false;
  canDelete:boolean = false;
  canCreate:boolean = false;
  viewUrl:string="";
  editUrl:string="";
  createUrl:string="";
  deleteUrl:string="";
  menuId:number = 0;
	menuUrl : string = "";
  userType = "";
  distributorList:any = [];
  distributorId:number=0;
  resellerList:any = [];
  resellerId:number = 0 ;
  agentList:any = [];
  agentId:number = 0 ;
  showLoader:boolean = false;
  addBeneficiary() {
    this.stepperDialogComponent.show = true;
  }

  constructor(private adminService: AdminService, private router:Router, private menuService:MenuService,private generalService: GeneralService) {
    let obj = this.router.getCurrentNavigation()?.extras?.state;
    if(obj)
    {    
      this.menuId = parseInt(obj['menuId'])??0;
      this.menuUrl = obj['menuUrl'];  
      this.getPermissions(this.menuId);
    }
    this.userType = this.generalService.getUserType();
    debugger;
    if(this.userType == '2')
    {
      this.bindDistributorDDL();
    }
    else if(this.userType == '2' || this.userType == '3')
    {
      this.bindResellerDDL();
    }
    else
    {
      this.bindAgentDDL();
    }

    this.getCustomerDetails();
  }

  async getCustomerDetails() {
    this.showLoader = true;
    const res = await this.adminService.CustomerDetails(this.agentId??0); 
    this.showLoader = false;   
    if (res != null && res.result) {
      this.graphdata = res.result.data;
      let index=3;
      let sort:string='asc';
      console.log(this.graphdata.sort( (a, b) => {
        if(sort == 'desc')
        {
          if (a[index].toString().toLowerCase() > b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() > a[index].toString().toLowerCase()) {
              return 1;
          }          
        }
        else
        {
          if (a[index].toString().toLowerCase() < b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() < a[index].toString().toLowerCase()) {
              return 1;
          }  
        }
        return index;
      }));
      this.graphHeader = res.result.header;
      this.visibleColumnData =  res.result.header.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
      this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
    }
  }

  onActionClick(data:any)
  {
    if(data)
    {
      if(data.action=="View")
      {
        this.router.navigateByUrl(this.viewUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      }
      else if(data.action=="Edit")
      {
        this.router.navigateByUrl(this.editUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      } 
    }
  }
  
  onCreateBtnClick(data:any)
  {
    this.router.navigateByUrl(this.createUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
  }

  async getPermissions(menuId:number)
  {
    let obj = {uniqueUserId:this.generalService.getUniqueuserid(),menuId:menuId};
    let res = await this.menuService.GetMenuPermissionsByUserId(obj);
    if(res && res.isSuccess)
    {
      if(res.result.userMenus.length > 0)
      {
        res.result.userMenus.forEach((element:any) => {
          if(element.permissionName.toLowerCase() =="create")
          {
            this.canCreate = true;
            this.createUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="edit")
          {
            this.canEdit = true;
            this.editUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="view")
          {
            this.canView = true;
            this.viewUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="delete")
          {
            this.canDelete = true;
            this.deleteUrl = element.menuCommand;
          }
        });
      }      
    }
  }

  async bindDistributorDDL()
  {
    const res = await this.adminService.DistributorDropDown().then((response)=> { 
      if (response != null && response.result) {
          this.distributorList = response.result.map((m:any)=>{return {id:m.id,name:m.name}});
          this.distributorList.unshift({id:"0",name:"All"});
          if(this.distributorList.length > 0 ){
            this.distributorId = parseInt(this.distributorList[0].id??"0");
          }
          this.bindResellerDDL();
      }   
    });
  }

  async bindResellerDDL()
  {
    const res = await this.adminService.ResellerDropDownByDistributorId(this.distributorId);  
    if (res != null && res.result) {
        this.resellerList = res.result.map((m:any)=>{return {id:m.id,name:m.name}});
        if(this.distributorId == 0){
          this.resellerList.unshift({id:"0",name:"All"});
        }
        if(this.resellerList.length > 0){
          this.resellerId = parseInt(this.resellerList[0].id??"0");
        }
        this.bindAgentDDL();
    }  
  }
  
  async bindAgentDDL()
  {
    const res = await this.adminService.AgentDropDownByResellerId(this.resellerId);  
    if (res != null && res.result) {
        this.agentList = res.result.map((m:any)=>{return {id:m.id,name:m.name}});
        if(this.resellerId == 0){
          this.agentList.unshift({id:"0",name:"All"});
        }
        if(this.agentList.length > 0){
          this.agentId = parseInt(this.agentList[0].id??"0");
        }
    }  
  }
}
